import { configureStore } from "@reduxjs/toolkit";
import userLoginReducer from "./UserLogin/UserState";
import manufacturerReducer from "./Admin/manufacturer";
import listManufacturerReducer from "./Admin/listManufacturer";

export default configureStore({
  reducer: {
    userLogin: userLoginReducer,
    manufacturer: manufacturerReducer,
    listManufacturer: listManufacturerReducer,
  },
});
